<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
            <v-btn icon :link="false" @click="back">
                <v-icon>fa-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles del Colaborador</v-toolbar-title>
  </v-toolbar>
    <v-container grid-list-md fluid>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos Personales</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Nombre(s)"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.primer_nombre"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Primer Apellido"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.primer_apellido"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Segundo Apellido"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.segundo_apellido"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-select
                  v-model="colaborador_info.sexo"
                  label="Sexo"
                  :items="tipo_sexo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Fecha Nacimiento"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.fecha_nacimiento"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Nacionalidad"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.nacionalidad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Originario"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.originario"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="CURP"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.curp"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Estado Civil"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.estado_civil"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="RFC"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.rfc"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Núm. SS"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.nss"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Domicilio"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.domicilio"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Colonia"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.colonia"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Localidad"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.ciudad"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Estado"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.estado"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Código Postal"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.codigo_postal"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Teléfono"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.telefono"
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  label="Celular"
                  placeholder=""
                  readonly
                  v-model="colaborador_info.celular"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Datos Empresa</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  label="Núm. Empleado"
                  readonly
                  v-model="colaborador_info.numero_empleado"
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  label="Credencial"
                  readonly
                  v-model="colaborador_info.credencial"
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  label="Vigencia Credencial"
                  readonly
                  v-model="colaborador_info.vigencia_credencial"
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-select
                  v-model="colaborador_info.status"
                  label="Estatus"
                  :items="tipo_status"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm8 md8>
                <v-textarea
                  v-model="colaborador_info.motivo"
                  :value="colaborador_info.motivo"
                  label="Motivo"
                  no-resize
                  rows="1"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.empresa"
                  label="Empresa"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.email"
                  label="Correo Electrónico"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.grupo"
                  label="Grupo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.fecha_contratacion"
                  label="Fecha Contratación"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.gerencia"
                  label="Gerencia"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.gerencia_desde"
                  label="Gerencia Desde"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.frente"
                  label="Frente"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.frente_desde"
                  label="Frente Desde"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.puesto"
                  label="Puesto"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.puesto_desde"
                  label="Puesto Desde"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.periodo_pago"
                  label="Periodo Pago"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-model="colaborador_info.periodo_pago_desde"
                  label="Periodo Pago Desde"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-textarea
                  label="Observaciones"
                  no-resize
                  rows="3"
                  readonly
                  v-model="colaborador_info.observaciones"
                  :value="colaborador_info.observaciones"
                />
              </v-flex>
            </v-layout>
            <HorariosColaboradores v-model="colaborator_hours" :editable="false" />
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <strong>Multimedia</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <img :src="colaborador_image()" style="width: 100%" alt="foto_rostro"/>
              </v-flex>
            </v-layout>
          </v-container>
  </div>
</template>
<script>
import HorariosColaboradores from '@/components/horarios_colaboradores.vue';
import colaboratorHours from '@/mixins/colaborator_hours';

export default {
  components: {
    HorariosColaboradores,
  },
  mixins: [colaboratorHours],
  data: () => ({
    colaborador_info: {},
    headers: [
      { text: 'Núm. Empleado', value: 'numero_empleado', sortable: true },
      { text: 'Credencial', value: 'credencial', sortable: true },
      { text: 'Nombre(s)', value: 'primer_nombre', sortable: true },
      { text: 'Primer Apellido', value: 'primer_apellido', sortable: true },
      { text: 'Segundo Apellido', value: 'segundo_apellido', sortable: true },
      { text: 'Empresa', value: 'empresa', sortable: true },
      { text: 'Gerencia', value: 'gerencia', sortable: true },
      { text: 'Estatus', value: 'status', sortable: true },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    tipo_status: [
      { text: 'Inactivo', value: 'inactivo' },
      { text: 'Activo', value: 'activo' },
      { text: 'Baja', value: 'baja' },
      { text: 'En Capacitación', value: 'capacitacion' },
    ],
    tipo_sexo: [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['detallesColaborador/is_loading'];
    },
    colaborador_processing() {
      return this.$store.getters['detallesColaborador/colaborador_processing'];
    },
  },
  watch: {
    colaborador_processing(val) {
      this.processing = val;
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    colaborador_image() {
      let encoded = '';
      let extension = '';
      if (typeof this.colaborador_info.rostros !== 'undefined' && this.colaborador_info.rostros.length > 0) {
        encoded = this.colaborador_info.rostros[this.colaborador_info.rostros.length - 1].image;
        const check = encoded.charAt(0);
        if (check === '/') {
          extension = 'jpg';
        } else if (check === '/') {
          extension = 'png';
        } else extension = 'tiff';
      } else {
        extension = 'jpeg';
        encoded = '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';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('detallesColaborador/fetchCollaboratorInfo', this.$route.params.id)
      .then((data) => {
        this.colaborador_info = data.colaborador;
        this.asign_colaborator_hours(data.colaborador);
      });
    this.editcolaborador = true;
    this.dialog = true;
  },
};
</script>
<style type="text/css">

</style>
